import { Box, Button, Container, Divider, FormControl, Grid, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import * as queryString from "query-string";
import React, { useEffect, useRef, useState } from "react";
import { QrReader } from "react-qr-reader";
import { useHistory } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import { qrScroll } from "../../common";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getPoolList } from "../../store/actions/breakDownTasksActions";
import { getMaintenanceType } from "../../store/actions/PMActions";
import { getEqGetByBarcodeContext } from "../../store/actions/EquipmentAction";
import { addToBePlanned, updateToBePlanned, getToBePlannedDetailById} from "../../store/actions/ToBePlannedActions";
import MaintenanceType from "../../components/Dropdowns/MaintenanceType/MaintenanceType";
import Machine from "../../components/TextFields/Machine/Machine";
import Shift from "../../components/Dropdowns/Shift";
import { getShifts } from "../../store/actions/ShiftActions";
import QrCode2Icon from '@mui/icons-material/QrCode2';
import CropFreeIcon from "@mui/icons-material/CropFree";
import SearchIcon from "@mui/icons-material/Search";

const useStyles = makeStyles((theme) => ({
    button: {
        width: 80,
        height: 80,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
}));

export default function CreateToBePlanned() {
    const classes = useStyles();
    const [pageLoaded, setPageLoaded] = useState(false);

    const toBePlannedId = queryString.parse(window.location.search).id;
    const fromPage = queryString.parse(window.location.search).from;
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();
    const history = useHistory();
    const [plannedPersons, setPlannedPersons] = useState(0);
    const [plannedHours, setPlannedHours] = useState(0);
    const [isDisable, setIsDisable] = useState(true);
    let [selectedPoolCode, setSelectedPoolCode] = useState(null);
    let [selectedPoolName, setSelectedPoolName] = useState(null);
    const [notes, setNotes] = useState("");

    const { shiftList } = useSelector(({ Shifts }) => Shifts);

    useEffect(() => {
        if (toBePlannedId !== undefined) {
            dispatch(getToBePlannedDetailById(toBePlannedId));
        }
        if (fromPage === "breakdown") {
            setSelectedPoolCode(parseInt(new URLSearchParams(window.location.search).get("poolid")));
            setSelectedPoolName(new URLSearchParams(window.location.search).get("poolname"));
            SetEquipment(parseInt(new URLSearchParams(window.location.search).get("equipmentid")), new URLSearchParams(window.location.search).get("equipmentname"));
            setNotes(new URLSearchParams(window.location.search).get("note"));
        }
        LoadHandler();
    }, []);

    const LoadHandler = () => {
        LoadPoolData();
        LoadMaintenanceTypesData();
        dispatch(getShifts());
    };

    const { ToBePlanned } = useSelector((ToBePlanned) => ToBePlanned);
    const { pm } = useSelector((pm) => pm);
    const { equipment } = useSelector((equipment) => equipment);
    const { breakDownTask } = useSelector((breakDownTask) => breakDownTask);

    const [recordStatus, setRecordStatus] = useState(0);
    useEffect(() => {
        if (ToBePlanned?.toBePlannedDetailById?.errorCode === 0 && toBePlannedId !== undefined) {
            const detail = ToBePlanned.toBePlannedDetailById.resultObject;
            setSelectedShiftType(detail.shiftNo);
            setPageLoaded(true);
            setNotes(detail.notes);
            setSelectedPoolCode(detail.poolId);
            setSelectedPoolName(detail.poolName);
            SetEquipment(detail.equipmentId, detail.equipmentName);
            setSelectedMaintenanceType(detail.maintenanceTypeId);
            setSelectedMaintenanceTypeName(detail.maintenanceTypeName);
            setPlannedPersons(detail.plannedPersonCount);
            setPlannedHours(detail.plannedHoursPerPerson);
            setRecordStatus(detail.recordStatus);
            ToBePlanned.toBePlannedDetailById = {};
        }
        if (ToBePlanned?.isTaskUpdated) {
            history.push({ pathname: "/to-be-planned" });
        }
    }, [ToBePlanned]);

    useEffect(() => {
        if (pm?.maintenanceType?.errorCode === 0) {
            setMaintenanceTypes(pm?.maintenanceType?.resultObject);
        }
    }, [pm]);

    useEffect(() => {
        if (equipment?.eqByBarCode?.resultObject) {
            const newMachineStates = {
                selectedAreaCode: equipment.eqByBarCode.resultObject?.areaId,
                selectedAreaName: equipment.eqByBarCode.resultObject?.areaName,
                selectedMainEquipmentCode: equipment.eqByBarCode.resultObject?.mainEquipmentId,
                selectedMainEquipmentName: equipment.eqByBarCode.resultObject?.mainEquipment,
                selectedSubEquipmentCode: equipment.eqByBarCode.resultObject?.id,
                selectedSubEquipmentName: equipment.eqByBarCode.resultObject?.name,
            };
            setMachineStates(newMachineStates);
            setQrOpen(false);
            equipment.eqByBarCode.resultObject = null;
        }
    }, [equipment?.eqByBarCode?.resultObject]);

    useEffect(() => {
        if (breakDownTask?.poolList?.errorCode === 0) {
            setPoolData(breakDownTask?.poolList?.resultObject);
            setPageLoaded(true);
        }
    }, [breakDownTask]);

    //load shift data
    let [shiftData, setShiftData] = useState([]);
    useEffect(() => {
        if (shiftList?.resultObject?.length > 0) {
            setShiftData(shiftList.resultObject[0].shifts);
        }
    }, [shiftList]);

    // Validation
    const [error, setError] = useState({
        machineText: t("SelectAMachine"),
        poolText: t("SelectAPool"),
        maintenanceNoteText: t("MaintenanceNote"),
    });

    useEffect(() => {
        const newSelectedPoolNameText = selectedPoolName ? "" : t("SelectAPool");
        const newNotesText = notes ? "" : t("MaintenanceNote");

        setError({
            ...error,
            poolText: newSelectedPoolNameText,
            maintenanceNoteText: newNotesText,
        });
    }, [selectedPoolName, notes]);

    useEffect(() => {
        if (error.poolText === "" && error.maintenanceNoteText === "" && (machineStates.selectedSubEquipmentCode || machineStates.selectedMainEquipmentCode)) {
            setIsDisable(false);
        } else {
            setIsDisable(true);
        }
    }, [error]);
    

    const SetEquipment = (id, name) => {
        if (id != null && name != null) {
            setMachineStates({ ...machineStates, selectedMainEquipmentCode: Number(id), selectedMainEquipmentName: name });
        }
    };

    const [maintenanceTypes, setMaintenanceTypes] = useState([]);
    const LoadMaintenanceTypesData = () => {
        dispatch(getMaintenanceType());
    };

    //load pool data
    let [poolData, setPoolData] = useState([]);
    const LoadPoolData = () => {
        dispatch(getPoolList());
    };

    const HandleNotes = (event) => {
        setNotes(event.target.value);
    };

    const HandlePoolChange = (poolId) => {
        if (poolId != null) {
            const filteredPool = poolData.filter((item) => item.name.includes(poolId));
            setSelectedPoolCode(filteredPool[0].id);
            setSelectedPoolName(filteredPool[0].name);
            return filteredPool[0].id;
        } else {
            setSelectedPoolCode(0);
            setSelectedPoolName("");
        }
    };

    const [selectedMaintenanceType, setSelectedMaintenanceType] = useState(null);
    const [selectedMaintenanceTypeName, setSelectedMaintenanceTypeName] = useState(null);
    const HandleMaintenanceTypeChange = (maintenanceId) => {
        if (maintenanceId != null) {
            const filteredType = maintenanceTypes.filter((item) => item.name.includes(maintenanceId));
            setSelectedMaintenanceType(filteredType[0].id);
            setSelectedMaintenanceTypeName(filteredType[0].name);
            return filteredType[0].id;
        } else {
            setSelectedMaintenanceType(0);
            setSelectedMaintenanceTypeName("");
        }
    };

    //submit request
    const AddToBePlannedHandler = () => {
        const data = {
            notes: notes,
            equipmentId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            poolId: selectedPoolCode || 0,
            maintenanceTypeId: selectedMaintenanceType || 0,
            plannedPersonCount: plannedPersons || 0,
            plannedHoursPerPerson: plannedHours || 0,
            shiftNo: parseInt(selectedShiftType),
        };
        dispatch(addToBePlanned(data));
    };

    const UpdateToBePlannedHandler = () => {
        const data = {
            id: parseInt(toBePlannedId),
            notes: notes,
            equipmentId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            poolId: selectedPoolCode || 0,
            maintenanceTypeId: selectedMaintenanceType || 0,
            plannedPersonCount: plannedPersons || 0,
            plannedHoursPerPerson: plannedHours || 0,
            recordStatus: recordStatus,
            shiftNo: parseInt(selectedShiftType),
        };
        dispatch(updateToBePlanned(data));
    };

    // Machine popup
    const initialMachineStates = {
        selectedAreaCode: null,
        selectedAreaName: null,
        selectedMainEquipmentCode: null,
        selectedMainEquipmentName: null,
        selectedSubEquipmentCode: null,
        selectedSubEquipmentName: null,
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);

    //QR Code
    let [qrOpen, setQrOpen] = useState(false);
    const [state, setState] = useState({
        result: "No result",
    });

    const qrRef = useRef();
    let executedScroll = false;
    const HandleScan = (data) => {
        executedScroll = qrScroll(qrRef, executedScroll);
        if (data) {
            setState({ ...state, result: data });
            dispatch(getEqGetByBarcodeContext(data));
        }
    };

    const onSubmitHandler = () => {
        if (toBePlannedId !== undefined) {
            UpdateToBePlannedHandler();
        } else {
            AddToBePlannedHandler();
        }
    };

    const [selectedShiftNo, setSelectedShiftNo] = useState("");
    const [selectedShiftType, setSelectedShiftType] = useState("");
    const HandleShift = (shiftNo) => {
        if (shiftNo != null) {
            const filteredType = shiftData.filter((item) => item.shiftNo == shiftNo);
            setSelectedShiftNo(filteredType[0].id);
            setSelectedShiftType(filteredType[0].shiftNo.toString());
            return filteredType[0].id;
        } else {
            setSelectedShiftNo(0);
            setSelectedShiftType("");
        }
    };

    let [barcodeOpen, setBarcodeOpen] = useState(false);
    const OpenBarcodeScanner = () => {
        if (barcodeOpen) {
            return (
                <div>
                    <TextField
                        autoFocus
                        onChange={(e) => HandleScanBarcode(e)}
                        onKeyDown={handleKeypress}
                        style={{ width: "100%", marginBottom: 10, marginTop: 20 }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton edge="end" color="primary" onClick={handleSubmit}>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
            );
        } else {
            return null;
        }
    };

    const HandleScanBarcode = (event) => {
        if (event.target.value) {
            setState({ ...state, result: event.target.value });
        }
    };

    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            setBarcodeOpen(false);
            dispatch(getEqGetByBarcodeContext(e.target.value));
        }
    };

    const handleSubmit = () => {
        setBarcodeOpen(false);
        dispatch(getEqGetByBarcodeContext(state.result));
    };

    return (
        <div>
            {pageLoaded === true ? (
                <Container id="ctbp_Container" fixed maxWidth="xs" style={{ marginTop: 20 }}>
                    <Grid id="ctbp_Grid" container justifyContent="center" style={{ marginTop: 30 }}>
                    <Grid id="rb_grid_1" item xs={12}>
                            <IconButton id="rb_iconQrBtn" onClick={() => setQrOpen(true)}>
                                <QrCode2Icon id="rb_centerFcs" className={classes.button} color="primary" />
                            </IconButton>
                            <IconButton id="rb_iconQrBtn" onClick={() => setBarcodeOpen(true)}>
                                <CropFreeIcon id="rb_centerFcs" className={classes.button} color="primary" />
                            </IconButton>
                        </Grid>
                        <Divider id="rb_divider" variant="middle" sx={{ width: "70%", marginTop: "10px" }} />
                        <Grid id="rb_grid_1" item xs={12}>
                            <TextField
                                id="ctbp_TextField_1"
                                multiline
                                maxRows={4}
                                defaultValue={t("ScanQRCodeOrChooseMachine")}
                                InputProps={{ readOnly: true }}
                                variant="outlined"
                                sx={{ width: "80%", marginTop: "10px" }}
                            />
                        </Grid>

                        <Grid id="ctbp_Grid_2" item xs={12}>
                            {qrOpen === true ? (
                                <div ref={qrRef}>
                                    <QrReader id="ctbp_QrReader" scanDelay={500} onResult={HandleScan} constraints={{ facingMode: "environment" }} style={{ width: "100%" }} />
                                </div>
                            ) : null}
                        </Grid>
                        {OpenBarcodeScanner()}
                        <Grid id="ctbp_Grid_4" item xs={12} style={{ marginTop: 10 }}>
                            <Box component="form">
                                <FormControl id="ctbp_FormControl" fullWidth margin="normal">
                                    <Machine setMachineStates={setMachineStates} machineStates={machineStates} isAreaNotFiltered={true} size="normal" error={error} setError={setError} />
                                </FormControl>

                                <FormControl id="ctbp_FormControl_2" fullWidth margin="normal">
                                    <MaintenanceType
                                        id="ctbp_mtype"
                                        selectedMaintenanceTypeName={selectedMaintenanceTypeName}
                                        HandleMaintenanceTypeChange={HandleMaintenanceTypeChange}
                                        maintenanceTypes={maintenanceTypes}
                                        style={{ marginTop: -20 }}
                                    />
                                </FormControl>

                                <FormControl id="ctbp_FormControl_3" fullWidth margin="normal">
                                    <TextField
                                        id="ctbp_TextField_4"
                                        multiline
                                        label={t("MaintenanceNote")}
                                        variant="outlined"
                                        onChange={HandleNotes}
                                        value={notes}
                                        error={error.maintenanceNoteText.length > 0}
                                        helperText={error.maintenanceNoteText ? error.maintenanceNoteText : notes.length == 550 ? t("MaxCharacter"): null}
                                        inputProps={{ maxLength: 550 }}
                                    />
                                </FormControl>

                                <FormControl id="ctbp_FormControl_4" fullWidth margin="normal">
                                    <Shift selectedShiftType={selectedShiftType} HandleShift={HandleShift} shiftData={shiftData} />
                                </FormControl>

                                <FormControl id="ctbp_FormControl_1" fullWidth margin="normal">
                                    <Autocomplete
                                        id="ctbp_Pool_Autocomplete"
                                        value={selectedPoolName}
                                        style={{ marginTop: -15 }}
                                        onChange={(event, newValue) => {
                                            HandlePoolChange(newValue);
                                        }}
                                        options={poolData.map((option) => option.name)}
                                        renderInput={(params) => (
                                            <TextField
                                                id="ctbp_TextField_3"
                                                {...params}
                                                margin="normal"
                                                label={t("Pool")}
                                                variant="outlined"
                                                error={error.poolText.length > 0}
                                                helperText={error.poolText}
                                            />
                                        )}
                                    />
                                </FormControl>

                                <FormControl margin="normal" sx={{ width: "47%" }}>
                                    <TextField
                                        type="number"
                                        onChange={(e) => setPlannedPersons((v) => (e.target.validity.valid ? e.target.value : v))}
                                        value={plannedPersons}
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4);
                                        }}
                                        InputProps={{
                                            inputProps: { min: 1 },
                                            endAdornment: <InputAdornment position="end">{t("Person")}</InputAdornment>,
                                        }}
                                        variant="outlined"
                                    />
                                </FormControl>

                                <FormControl margin="normal" sx={{ width: "47%", marginLeft: "10px" }}>
                                    <TextField
                                        type="number"
                                        onChange={(e) => setPlannedHours((v) => (e.target.validity.valid ? e.target.value : v))}
                                        value={plannedHours}
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4);
                                        }}
                                        InputProps={{
                                            inputProps: { min: 1 },
                                            endAdornment: <InputAdornment position="end">{t("Person/Hour")}</InputAdornment>,
                                        }}
                                        variant="outlined"
                                    />
                                </FormControl>

                                <FormControl margin="normal">
                                    <Button onClick={onSubmitHandler} id="ctbp_b_1" variant="contained" color="primary" disabled={isDisable}>
                                        {t("Save")}
                                    </Button>
                                </FormControl>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            ) : null}

            <LoadingBackdrop id="ctbp_lbd" />
        </div>
    );
}
